import { getActiveProfile } from "../contexts/ProfileContext";

export const API_BASE =
  import.meta.env.VITE_FUNC_BASE || "http://localhost:7071";

const ensureActiveProfile = () => {
  const profile = getActiveProfile();
  if (!profile) {
    throw new Error("Active profile is not set. Select a client profile to continue.");
  }
  return profile;
};

export const withProfile = (url: string): string => {
  const profile = ensureActiveProfile();
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}profile=${encodeURIComponent(profile)}`;
};

export const apiUrl = (
  path: string,
  options: { includeProfile?: boolean } = {}
): string => {
  const includeProfile = options.includeProfile ?? true;
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const base = `${API_BASE}${normalizedPath}`;
  return includeProfile ? withProfile(base) : base;
};
